import { createAsyncThunk } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";

//Include Both Helper File with needed methods
import AdsApi from "api/adsApi";
import { formatQueryParams } from "helpers/format";

export const getAdsPlanApi = async (params: any = {}) => {
  try {
    const response = await AdsApi.plans(formatQueryParams(params));
    return response;
  } catch (error) {
    return error;
  }
};

export const getAdsPlan = createAsyncThunk("AdsPlan", getAdsPlanApi);
